export default "__VITE_ASSET__BOyH_gb___"